import { render, staticRenderFns } from "./RTSP.vue?vue&type=template&id=88348070&scoped=true&"
import script from "./RTSP.vue?vue&type=script&lang=js&"
export * from "./RTSP.vue?vue&type=script&lang=js&"
import style0 from "./RTSP.vue?vue&type=style&index=0&id=88348070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88348070",
  null
  
)

export default component.exports